import { render, staticRenderFns } from "./translatable-field.vue?vue&type=template&id=12b8cd96&scoped=true&"
import script from "./translatable-field.vue?vue&type=script&lang=js&"
export * from "./translatable-field.vue?vue&type=script&lang=js&"
import style0 from "./translatable-field.vue?vue&type=style&index=0&id=12b8cd96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b8cd96",
  null
  
)

export default component.exports